import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, ErrorHandler, OnInit } from '@angular/core';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { AgmMap } from '@agm/core';
import { QuickNavToc } from '../../shared/models/quick-nav-toc.model';
import { QuickNavComponent } from '../../shared/quick-nav/quick-nav.component';
import { EventLocationComponent } from '../event-location/event-location.component';
import { ReviewReportOffensiveComponent } from '../../shared/review-report-offensive/review-report-offensive.component';
import { State } from '../../shared/state-view/state.model';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { AuthService } from '../../auth/auth/auth.service';
import { UserService } from '../../shared/user/user.service';
import { Router } from '@angular/router';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { EditEventImageComponent } from '../edit-event-image/edit-event-image.component';
import { DeleteEventImageComponent } from '../delete-event-image/delete-event-image.component';
import { DeleteEventComponent } from '../delete-event/delete-event.component';
import { CloneEventComponent } from '../clone-event/clone-event.component';
import { NgxGalleryImage, NgxGalleryOptions } from 'ngx-gallery';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
var EventDetailComponent = /** @class */ (function () {
    function EventDetailComponent(dialog, _auth, _userService, _errorHandler, _snackBar, _router, _aviationEventsService, businessManagerService, _toggleService, _analyticsService) {
        this.dialog = dialog;
        this._auth = _auth;
        this._userService = _userService;
        this._errorHandler = _errorHandler;
        this._snackBar = _snackBar;
        this._router = _router;
        this._aviationEventsService = _aviationEventsService;
        this.businessManagerService = businessManagerService;
        this._toggleService = _toggleService;
        this._analyticsService = _analyticsService;
        this.state = State.Empty;
        this.isEventOwner = false;
        this.editModeSet = false;
        this.isFlightDeckAdmin = false;
        this.toc = new QuickNavToc('fbo-quicknav', [{
                label: 'Description',
                fragment: 'description',
                visible: true
            }, {
                label: 'Venue/Location',
                fragment: 'location',
                visible: true
            }, {
                label: 'Event Details',
                fragment: 'details',
                visible: true
            }, {
                label: 'Contact Info',
                fragment: 'contact',
                visible: true
            }, {
                label: 'Travel Discounts',
                fragment: 'travel',
                visible: true
            }]);
    }
    EventDetailComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.businessManagerService.userOwnsEvent(this.aviationEvent.recid)];
                    case 1:
                        _a.isEventOwner = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.businessManagerService.isFlightDeckAdmin()];
                    case 2:
                        _b.isFlightDeckAdmin = _c.sent();
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        this.galleryOptions = [
                            {
                                width: '391px',
                                height: '489px',
                                thumbnailsColumns: 3,
                                image: true,
                                imageSize: 'contain',
                                preview: true,
                                previewCloseOnClick: true,
                                previewCloseOnEsc: true,
                                thumbnailsMargin: 5,
                                thumbnailMargin: 5,
                                imageArrows: true,
                                imageArrowsAutoHide: false,
                                previewArrows: true,
                                thumbnailsArrowsAutoHide: true
                            }
                        ];
                        if (this.aviationEvent.galleryPhotos) {
                            this.galleryImages = this.aviationEvent.galleryPhotos;
                            if (this.aviationEvent.galleryPhotos.length === 1) {
                                this.galleryOptions = [
                                    {
                                        width: '391px',
                                        height: '489px',
                                        thumbnailsColumns: 3,
                                        image: true,
                                        imageSize: 'contain',
                                        preview: true,
                                        previewCloseOnClick: true,
                                        previewCloseOnEsc: true,
                                        thumbnailsMargin: 5,
                                        thumbnailMargin: 5,
                                        imageArrows: false,
                                        imageArrowsAutoHide: false,
                                        previewArrows: false,
                                        thumbnailsArrowsAutoHide: true
                                    }
                                ];
                            }
                        }
                        else {
                            this.galleryImages = [];
                        }
                        this._analyticsService.pageView('airport_event', 'Event Detail');
                        this._analyticsService.trackEvent('airport_event_viewed', this.aviationEvent.eventId.toString(), this.aviationEvent.eventId.toString());
                        if (this._auth.authenticated && this._auth.endUser) {
                            this._analyticsService.trackEvent('airport_event_loggedin', this._auth.recid, this._auth.recid);
                        }
                        else {
                            this._analyticsService.trackEvent('airport_event_loggedout', '', '');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    EventDetailComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var nativeMap;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.aviationEvent.location) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._initMap()];
                    case 1:
                        nativeMap = _a.sent();
                        nativeMap.setCenter({ lat: this.aviationEvent.location.lat, lng: this.aviationEvent.location.lon });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    EventDetailComponent.prototype._initMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.map.mapReady.subscribe(function (map) {
                            _this._nativeMap = map;
                            resolve(map);
                        }, function (err) { return reject(err); });
                    })];
            });
        });
    };
    Object.defineProperty(EventDetailComponent.prototype, "directionsURL", {
        get: function () {
            return this.aviationEvent.zipcode ? this.aviationEvent.address1 + '+' + this.aviationEvent.city + '+' +
                this.aviationEvent.stateProvince + '+' + this.aviationEvent.zipcode
                : this.aviationEvent.address1 + '+' + this.aviationEvent.city + '+' +
                    this.aviationEvent.stateProvince;
        },
        enumerable: true,
        configurable: true
    });
    EventDetailComponent.prototype.dataChanged = function (aviationEvent) {
        this.aviationEvent = aviationEvent;
    };
    EventDetailComponent.prototype.reloadEntity = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._aviationEventsService.getAviationEventById(this.aviationEvent.eventId)];
                    case 1:
                        _a.aviationEvent = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EventDetailComponent.prototype.reportOffensive = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (!this._auth.authenticated || !this._auth.endUser) {
                    this._auth.redirectToLogin();
                    return [2 /*return*/];
                }
                dialogRef = this.dialog.open(ReviewReportOffensiveComponent, {
                    width: '550px',
                    data: {
                        offensiveType: 'event'
                    }
                });
                dialogRef.afterClosed().subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var snackBarOpts, response, e_1;
                    var _this = this;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!result) return [3 /*break*/, 4];
                                snackBarOpts = { duration: 2000 };
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this._userService.setAviationEventInteraction(this.aviationEvent.eventId, 'Offensive')];
                            case 2:
                                response = _a.sent();
                                this.state = State.Content;
                                this.reloadEntity();
                                this._snackBar.open('Thank you.  Your report has been logged and will be reviewed as soon as possible.', 'Dismiss', { duration: 6000 });
                                return [3 /*break*/, 4];
                            case 3:
                                e_1 = _a.sent();
                                this._snackBar.open('An error occurred saving report. Please try again later.', 'Dismiss', snackBarOpts);
                                this._errorHandler.handleError(e_1);
                                // Set state to error, then reset after a few seconds to allow retry.
                                this.state = State.Error;
                                setTimeout(function () {
                                    _this.state = State.Content;
                                }, 2000);
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    EventDetailComponent.prototype.removeOffensive = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var snackBarOpts, response, e_2;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.endUser) {
                            this._auth.redirectToLogin();
                            return [2 /*return*/];
                        }
                        snackBarOpts = { duration: 2000 };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._userService.setAviationEventInteraction(this.aviationEvent.eventId, 'ClearOffensive')];
                    case 2:
                        response = _a.sent();
                        this.state = State.Content;
                        this.reloadEntity();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        this._snackBar.open('An error occurred removing your report. Please try again later.', 'Dismiss', snackBarOpts);
                        this._errorHandler.handleError(e_2);
                        // Set state to error, then reset after a few seconds to allow retry.
                        this.state = State.Error;
                        setTimeout(function () {
                            _this.state = State.Content;
                        }, 2000);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EventDetailComponent.prototype.clearAllOffensive = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var snackBarOpts, response, e_3;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.endUser) {
                            this._auth.redirectToLogin();
                            return [2 /*return*/];
                        }
                        snackBarOpts = { duration: 2000 };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._userService.setAviationEventInteraction(this.aviationEvent.eventId, 'NotOffensive')];
                    case 2:
                        response = _a.sent();
                        this.state = State.Content;
                        this.reloadEntity();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        this._snackBar.open('An error occurred removing your report. Please try again later.', 'Dismiss', snackBarOpts);
                        this._errorHandler.handleError(e_3);
                        // Set state to error, then reset after a few seconds to allow retry.
                        this.state = State.Error;
                        setTimeout(function () {
                            _this.state = State.Content;
                        }, 2000);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EventDetailComponent.prototype.openEditImageDialog = function () {
        var DATA = { aviationEvent: this.aviationEvent };
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '800px';
        dialogConfig.data = DATA;
        var DIALOG_REF = this.dialog.open(EditEventImageComponent, dialogConfig);
        this._handleModalClose(DIALOG_REF);
    };
    /**
     * listens for dialog close event. Opens snackbar if necessary
     * @param {MatDialogRef<any>} dialogRef
     * @param {string} successMessage
     * @param {string} actionMessage
     * @private
     */
    EventDetailComponent.prototype._handleModalClose = function (dialogRef, successMessage, actionMessage) {
        var _this = this;
        if (successMessage === void 0) { successMessage = 'Event Cover Photo/Image'; }
        if (actionMessage === void 0) { actionMessage = 'Updated'; }
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogRef.afterClosed().subscribe(function (success) {
            if (success === null) {
                return;
            }
            if (success.cancelBtnClicked) {
                return;
            }
            if (success) {
                if (successMessage === 'Aviation Event') {
                    _this._router.navigate(['/'], { queryParams: { 't': 'events' } });
                }
                else {
                    _this.reloadEntity();
                }
                _this._snackBar.open(successMessage, actionMessage, {
                    duration: 5000
                });
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    EventDetailComponent.prototype.openDeleteImageDialog = function () {
        var DATA = { aviationEvent: this.aviationEvent };
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '800px';
        dialogConfig.data = DATA;
        var DIALOG_REF = this.dialog.open(DeleteEventImageComponent, dialogConfig);
        this._handleModalClose(DIALOG_REF, 'Event Cover Photo/Image', 'Deleted');
    };
    EventDetailComponent.prototype.openDeleteEventDialog = function () {
        var DATA = { aviationEvent: this.aviationEvent };
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '800px';
        dialogConfig.data = DATA;
        var DIALOG_REF = this.dialog.open(DeleteEventComponent, dialogConfig);
        this._handleModalClose(DIALOG_REF, 'Aviation Event', 'Deleted');
    };
    EventDetailComponent.prototype.openCloneEventDialog = function () {
        var DATA = { aviationEvent: this.aviationEvent };
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '800px';
        dialogConfig.data = DATA;
        var DIALOG_REF = this.dialog.open(CloneEventComponent, dialogConfig);
        this._handleModalClose(DIALOG_REF, 'Event Clone Created', 'And Currently Showing');
    };
    return EventDetailComponent;
}());
export { EventDetailComponent };
